export enum CompanyProfileTranslations {
  searchCandidates = 'companyProfile.searchCandidates',
  goToDashboard = 'companyProfile.goToDashboard',
  messageCenter = 'companyProfile.messageCenter',
}
